import React, { useRef } from 'react';
import ContactHero from './components/ContactHero';
import ConsultationForm from './components/ConsultationForm';
import InstantValueSection from './components/InstantValueSection';
import ContactMethods from './components/ContactMethods';
import TrustAccelerators from './components/TrustAccelerators';

const ContactConsultation = () => {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <ContactHero onScrollToForm={scrollToForm} />
      
      <div ref={formRef}>
        <ConsultationForm />
      </div>
      
      {/* <InstantValueSection /> */}
      {/* <ContactMethods /> */}
      {/* <TrustAccelerators /> */}
    </>
  );
};

export default ContactConsultation;